(() => {
  const accordion = document.querySelector('.cc-sticky-accordion');

  if (!accordion || accordion.dataset.initialized === 'true') return;

  accordion.dataset.initialized = 'true';

  const header = document.querySelector('.header-wrapper');
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const tabs = [...accordion.querySelectorAll('.cc-tab')];
  const targetTabs = tabs.filter((tab) => tab.dataset.tab !== 'top');
  let animationFrame;

  const availableTabs = targetTabs.filter((tab) => {
    const target = document.querySelector(tab.dataset.tab);
    const listItem = tab.closest('li');

    if (!target && listItem) listItem.hidden = true;

    return Boolean(target);
  });

  if (!availableTabs.length) {
    accordion.hidden = true;
    return;
  }

  accordion.querySelectorAll('img[cc-data-src]').forEach((image) => {
    image.src = image.getAttribute('cc-data-src');
    image.removeAttribute('cc-data-src');
  });

  const getHeaderOffset = () => {
    if (!header || header.closest('.section-header')?.classList.contains('shopify-section-header-hidden')) return 0;

    const rect = header.getBoundingClientRect();
    return rect.bottom > 0 ? rect.bottom : 0;
  };

  const updatePosition = () => {
    animationFrame = undefined;

    if (!mobileViewport.matches) {
      accordion.style.display = 'none';
      accordion.style.top = '0';
    } else if (window.scrollY > 0) {
      accordion.style.display = 'block';
      accordion.style.top = `${getHeaderOffset()}px`;
    } else {
      accordion.style.display = 'none';
      accordion.style.top = '0';
    }
  };

  const requestPositionUpdate = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(updatePosition);
  };

  const scrollToTarget = (tab) => {
    const selector = tab.dataset.tab;

    if (selector === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const target = document.querySelector(selector);
      if (!target) return;

      const top = target.getBoundingClientRect().top + window.scrollY - accordion.offsetHeight - getHeaderOffset() - 10;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

      window.setTimeout(() => {
        const correctedTop =
          target.getBoundingClientRect().top + window.scrollY - accordion.offsetHeight - getHeaderOffset() - 10;
        window.scrollTo({ top: Math.max(0, correctedTop), behavior: 'smooth' });
      }, 400);
    }

    tabs.forEach((item) => {
      item.classList.remove('active');
      item.removeAttribute('aria-current');
    });
    tab.classList.add('active');
    tab.setAttribute('aria-current', 'true');
  };

  accordion.addEventListener(
    'click',
    (event) => {
      const tab = event.target.closest('.cc-tab');
      if (!tab) return;

      event.preventDefault();
      event.stopPropagation();
      scrollToTarget(tab);
    },
    true
  );

  window.addEventListener('scroll', requestPositionUpdate, { passive: true });
  window.addEventListener('resize', requestPositionUpdate);

  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(requestPositionUpdate).observe(header);
  }

  updatePosition();
})();
